import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/services/alert.service';

@Component({ selector: 'alert', templateUrl: 'alert.component.html', styleUrls:['alert.component.scss'] })
export class AlertComponent implements OnInit, OnDestroy {
    //@ViewChild('alert', { read: true }) alert: ElementRef;
    private subscription: Subscription;
    message: any;

    constructor(private alertService: AlertService) { }

    ngOnInit() {
        this.subscription = this.alertService.getAlert()
            .subscribe(message => {
                switch (message && message.type) {
                    case 'success':
                        message.cssClass = 'alert alert-success';
                        break;
                    case 'error':
                        message.cssClass = 'alert alert-danger';
                        break;
                }

                this.message = message;
            });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    closeAlert() {
        this.message = null;
    }
}